import { LeadConfig } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    configs: [],
  },
  actions: {
    async fetchConfigs({ commit }) {
      const configs = await LeadConfig.fetch({})
      commit('changeState', { configs })
    },
  },
  getters: {
    configs: state => state.configs,
  },
}
